/**
 * 基础组件索引（与 Foundation.vue / Layout 侧栏对齐）
 * @typedef {{ id: string, title: string, path: string, subtitle?: string }} PreviewCatalogItem
 * @typedef {{ title: string, items: PreviewCatalogItem[] }} PreviewCatalogGroup
 */

/** @type {PreviewCatalogGroup[]} */
export const FOUNDATION_CATALOG_GROUPS = [
  {
    title: '规范与资源',
    items: [
      { id: 'colors', title: 'Color System', path: '/colors', subtitle: '颜色系统' },
      { id: 'typography', title: '字体系统', path: '/typography' },
      { id: 'icon', title: 'Icon 图标', path: '/icon' },
    ],
  },
  {
    title: '入门',
    items: [
      { id: 'foundation', title: '常用基础组件', path: '/foundation', subtitle: '组件总览' },
    ],
  },
  {
    title: '导航与结构',
    items: [
      { id: 'el-menu', title: 'Menu 导航菜单', path: '/el-menu' },
      { id: 'el-tabs', title: 'Tabs 标签页', path: '/el-tabs' },
      { id: 'pm-segmented-tabs', title: 'PmSegmentedTabs 胶囊分段', path: '/pm-segmented-tabs' },
      { id: 'el-breadcrumb', title: 'Breadcrumb 面包屑', path: '/el-breadcrumb' },
      { id: 'el-page-header', title: 'PageHeader 页头', path: '/el-page-header' },
      { id: 'el-steps', title: 'Steps 步骤条', path: '/el-steps' },
    ],
  },
  {
    title: '表格与分页',
    items: [
      { id: 'el-table', title: 'Table 表格', path: '/el-table' },
      { id: 'pm-concrete-loss-tree-table', title: 'PmConcreteLossTreeTable', path: '/pm-concrete-loss-tree-table' },
      { id: 'pm-grey-strip-list', title: 'PmGreyStripList 条带列表', path: '/pm-grey-strip-list' },
      { id: 'el-tree', title: 'Tree 树形控件', path: '/el-tree' },
      { id: 'el-pagination', title: 'Pagination 分页', path: '/el-pagination' },
    ],
  },
  {
    title: '表单与输入',
    items: [
      { id: 'native-overlay', title: '原生浮层 Dropdown/Droplist', path: '/native-overlay' },
      { id: 'el-form', title: 'Form 表单', path: '/el-form' },
      { id: 'el-input', title: 'Input 输入框', path: '/el-input' },
      { id: 'el-input-number', title: 'InputNumber 数字输入', path: '/el-input-number' },
      { id: 'el-autocomplete', title: 'Autocomplete 自动补全', path: '/el-autocomplete' },
      { id: 'el-select', title: 'Select 选择器', path: '/el-select' },
      { id: 'el-cascader', title: 'Cascader 级联选择', path: '/el-cascader' },
      { id: 'el-date-picker', title: 'DatePicker 日期选择', path: '/el-date-picker' },
      { id: 'el-checkbox', title: 'Checkbox 多选框', path: '/el-checkbox' },
      { id: 'el-radio', title: 'Radio 单选框', path: '/el-radio' },
      { id: 'el-switch', title: 'Switch 开关', path: '/el-switch' },
      { id: 'el-slider', title: 'Slider 滑块', path: '/el-slider' },
      { id: 'el-rate', title: 'Rate 评分', path: '/el-rate' },
      { id: 'el-transfer', title: 'Transfer 穿梭框', path: '/el-transfer' },
      { id: 'el-mention', title: 'Mention 提及', path: '/el-mention' },
      { id: 'el-input-tag', title: 'InputTag 标签输入', path: '/el-input-tag' },
      { id: 'el-upload', title: 'Upload 上传', path: '/el-upload' },
    ],
  },
  {
    title: '按钮与展示',
    items: [
      { id: 'el-button', title: 'Button 按钮', path: '/el-button' },
      { id: 'el-tag', title: 'Tag 标签', path: '/el-tag' },
      { id: 'el-badge', title: 'Badge 标记', path: '/el-badge' },
      { id: 'el-divider', title: 'Divider 分割线', path: '/el-divider' },
      { id: 'el-image', title: 'Image 图片', path: '/el-image' },
      { id: 'el-descriptions', title: 'Descriptions 描述列表', path: '/el-descriptions' },
      { id: 'el-collapse', title: 'Collapse 折叠面板', path: '/el-collapse' },
      { id: 'el-timeline', title: 'Timeline 时间线', path: '/el-timeline' },
      { id: 'el-skeleton', title: 'Skeleton 骨架屏', path: '/el-skeleton' },
      { id: 'el-empty', title: 'Empty 空状态', path: '/el-empty' },
      { id: 'el-progress', title: 'Progress 进度条', path: '/el-progress' },
      { id: 'el-result', title: 'Result 结果', path: '/el-result' },
      { id: 'notice-card', title: 'NoticeCard 提示卡片', path: '/notice-card' },
    ],
  },
  {
    title: '反馈与浮层',
    items: [
      { id: 'el-dialog', title: 'Dialog 对话框', path: '/el-dialog' },
      { id: 'el-drawer', title: 'Drawer 抽屉', path: '/el-drawer' },
      { id: 'el-alert', title: 'Alert 警告', path: '/el-alert' },
      { id: 'el-loading', title: 'Loading 加载', path: '/el-loading' },
      { id: 'el-message', title: 'Message 消息提示', path: '/el-message' },
      { id: 'el-message-box', title: 'MessageBox 弹框', path: '/el-message-box' },
      { id: 'el-tooltip', title: 'Tooltip 文字提示', path: '/el-tooltip' },
      { id: 'el-popover', title: 'Popover 弹出框', path: '/el-popover' },
      { id: 'el-popconfirm', title: 'Popconfirm 气泡确认框', path: '/el-popconfirm' },
    ],
  },
];
